import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {
  private darkModeKey = 'darkMode';
  private readonly mudou = new Subject<boolean>();
  /** Emite o novo estado (true = escuro) a cada troca. */
  readonly mudou$ = this.mudou.asObservable();

  constructor() {
    this.loadInitialDarkMode();
  }

  isDarkMode(): boolean {
    return localStorage.getItem(this.darkModeKey) === 'enabled';
  }

  enableDarkMode(): void {
    document.documentElement.classList.add('dark');
    localStorage.setItem(this.darkModeKey, 'enabled');
    this.mudou.next(true);
  }

  disableDarkMode(): void {
    document.documentElement.classList.remove('dark');
    localStorage.setItem(this.darkModeKey, 'disabled');
    this.mudou.next(false);
  }

  toggleDarkMode(): void {
    this.isDarkMode() ? this.disableDarkMode() : this.enableDarkMode();
  }

  private loadInitialDarkMode(): void {
    if (this.isDarkMode()) {
      this.enableDarkMode();
    } else {
      this.disableDarkMode();
    }
  }
}
